// 格式化日期工具函數

/**
 * 格式化日期為本地日期字符串
 * @param {string|number} dateString - 日期字符串或時間戳
 * @returns {string} 格式化後的日期字符串
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    // 處理字符串格式的時間戳
    const timestamp = parseInt(dateString);
    if (isNaN(timestamp)) {
      return new Date(dateString).toLocaleDateString();
    }
    return new Date(timestamp).toLocaleDateString();
  } catch (error) {
    console.error('日期格式化錯誤:', error);
    return '';
  }
};

/**
 * 格式化日期為本地日期時間字符串
 * @param {string|number} dateString - 日期字符串或時間戳
 * @returns {string} 格式化後的日期時間字符串
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  try {
    // 處理字符串格式的時間戳
    const timestamp = parseInt(dateString);
    if (isNaN(timestamp)) {
      return new Date(dateString).toLocaleString();
    }
    return new Date(timestamp).toLocaleString();
  } catch (error) {
    console.error('日期時間格式化錯誤:', error);
    return '';
  }
};

/**
 * 格式化日期為相對時間（例如：2小時前）
 * @param {string|number} dateString - 日期字符串或時間戳
 * @returns {string} 相對時間字符串
 */
export const formatRelativeTime = (dateString) => {
  if (!dateString) return '';
  try {
    const timestamp = parseInt(dateString);
    const date = isNaN(timestamp) ? new Date(dateString) : new Date(timestamp);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 60) {
      return '剛剛';
    } else if (diffInSeconds < 3600) {
      return `${Math.floor(diffInSeconds / 60)}分鐘前`;
    } else if (diffInSeconds < 86400) {
      return `${Math.floor(diffInSeconds / 3600)}小時前`;
    } else if (diffInSeconds < 2592000) {
      return `${Math.floor(diffInSeconds / 86400)}天前`;
    } else {
      return date.toLocaleDateString();
    }
  } catch (error) {
    console.error('相對時間格式化錯誤:', error);
    return '';
  }
}; 